var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_10","data-name":"Ellipse 10","cx":"24","cy":"24","r":"24","fill":"#fff","key":0}),React.createElement("path",{"id":"Icon_awesome-facebook","data-name":"Icon awesome-facebook","d":"M48.562,24.709a24,24,0,1,0-27.75,23.854V31.689h-6.1v-6.98h6.1v-5.32c0-6.051,3.581-9.394,9.065-9.394a36.719,36.719,0,0,1,5.373.471v5.939H32.223c-2.981,0-3.911,1.862-3.911,3.771v4.532h6.656L33.9,31.689H28.312V48.563A24.11,24.11,0,0,0,48.562,24.709Z","transform":"translate(-0.563 -0.563)","fill":"#e62a2c","key":1})]);
}

Facebook.defaultProps = {"id":"Facebook","viewBox":"0 0 48 48"};

module.exports = Facebook;

Facebook.default = Facebook;
